var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.display ? _c('div', {
    staticClass: "page_loader"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "0",
    staticClass: "quote_container"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/yeti_grover_logo.png")
    }
  }), _c('div', {
    staticClass: "quote"
  }, [_vm._v(" \"" + _vm._s(_vm.quote.quote) + "\" "), _c('br'), _vm._v(" - " + _vm._s(_vm.quote.author) + " ")])]), _c('v-progress-circular', {
    key: "1",
    attrs: {
      "size": 16,
      "width": 2,
      "color": "#E84970",
      "indeterminate": ""
    }
  }), _c('div', {
    key: "2",
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message))]), _vm.contentId ? _c('div', {
    key: "3",
    staticClass: "content_id"
  }, [_vm._v(" " + _vm._s(_vm.contentId) + " ")]) : _vm._e()], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }